import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetApplicationByFundraisingId = fundraisingId => {
  return useQuery({
    enabled: !!fundraisingId,
    queryKey: [QUERY_KEYS.fundraising.application_by_fundraising_id, fundraisingId],
    queryFn: () =>
      fundraisingService.application({ fundraising_id: fundraisingId }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }

        throw new Error('Error fetching founder application');
      }),
  });
};
